import styled from 'styled-components';
import Button from '../common/Button';
import { copyToClipboard } from '../../utils/functions';
import { URL } from '../../utils/constants';
import KakaoShare from '../KakaoShare';

const InfoFooter = () => {
  return (
    <StyledFooter>
      <StyledUl>
        <li>
          <KakaoShare />
        </li>
        <li>
          <Button type="button" onClick={() => copyToClipboard(URL)}>
            링크 복사하기
          </Button>
        </li>
      </StyledUl>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  font-size: 1.6rem;
  line-height: 2.4rem;
  padding: 3rem 0;
  text-align: center;
`;

const StyledUl = styled.ul`
  display: flex;
  justify-content: center;
  gap: 3rem;
`;

export default InfoFooter;
